/**
 * Queue Domain Types (Original)
 *
 * Original queue types for queue management (status, tabs, store).
 * These are separate from the listing API types.
 */

import type { CaseId, CaseSummary } from '@/shared/types';

// ============================================================================
// Queue-specific Types
// ============================================================================

export enum QueueStatus {
  Running = 'RUNNING',
  Paused = 'PAUSED',
  Stopped = 'STOPPED',
}

export enum QueueTab {
  Queue = 'queue',
  FollowUps = 'follow-ups',
  History = 'history',
}

export interface QueueState {
  status: QueueStatus;
  currentCaseId: CaseId | null;
  cases: CaseSummary[];
  completedCount: number;
  activeTab: QueueTab;
}

export interface QueueActions {
  startQueue: () => void;
  pauseQueue: () => void;
  stopQueue: () => void;
  setCurrentCase: (caseId: CaseId | null) => void;
  nextCase: () => void;
  setCases: (cases: CaseSummary[]) => void;
  setActiveTab: (tab: QueueTab) => void;
}

export type QueueStore = QueueState & QueueActions;
